module.exports = __webpack_public_path__ + "img/dead-svgrepo.7e8a706c.svg";